import {ITTIModelBase} from '@/ittijs/ITTIModel';
export default class extends ITTIModelBase {
	constructor() {
		super('SessionCompare');
	}
	brl(session1: number, session2: number, getController: Function|null = null){
		return this.fetch('brl', {session1,session2}, null, getController);
	}
}